export default __webpack_public_path__ + "static/media/js.e35fa00e.png";